import * as React from 'react';
import { useColorScheme } from '@mui/material/styles';

/**
 * Component that dynamically updates the meta theme-color tag
 * to match the header background color for iOS Safari safe area
 */
export function ThemeColorMeta() {
    const { mode } = useColorScheme();
    
    React.useEffect(() => {
        // Find or create the theme-color meta tag
        let metaThemeColor = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement;
        
        if (!metaThemeColor) {
            metaThemeColor = document.createElement('meta');
            metaThemeColor.name = 'theme-color';
            document.head.appendChild(metaThemeColor);
        }
        
        // Update theme color based on current mode
        // Light mode: hsl(220, 35%, 97%) = #F0F2F5
        // Dark mode: hsl(220, 20.00%, 14.70%) = #1F2329
        if (mode === 'dark') {
            metaThemeColor.content = '#1F2329';
        } else {
            metaThemeColor.content = '#F0F2F5';
        }
    }, [mode]);
    
    return null;
}

